export class TipoUsuarioI {
  idTipoUsuario : number;
  nombreTipo : String;
  desTipo: String;
  usTipoTipo: String;
}
